module.exports = __webpack_public_path__ + "static/img/alumina-solution_256.b6fff5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alumina-solution_256.png
// module id = DtHn
// module chunks = 0